export const INCREASE_DIFFICULTY_LEVEL = 'timewreck/player/INCREASE_DIFFICULTY_LEVEL';

export const PLAYER_FETCH = 'timewreck/player/FETCH';
export const PLAYER_FETCH_SUCCESS = 'timewreck/player/FETCH.SUCCESS';
export const PLAYER_FETCH_FAILURE = 'timewreck/player/FETCH.FAILURE';
